import { Phone, Mail, MapPin, Facebook, Instagram } from "lucide-react";
import { Link } from "react-router-dom";
import { LANDING_LINKS } from "@/lib/seoPages";
import { ShareButton } from "@/components/ShareButton";
import { InstallAppButton } from "@/components/InstallAppButton";
import { WhatsAppIcon } from "@/components/WhatsAppIcon";

const waLink = (num) => `https://wa.me/${num}?text=${encodeURIComponent("Ciao! Vorrei informazioni sul noleggio auto a Pontedera.")}`;

const WaBtn = ({ num, name }) => (
  <a href={waLink(num)} target="_blank" rel="noopener noreferrer" aria-label={`Scrivi a ${name} su WhatsApp`} data-testid={`whatsapp-${name.toLowerCase()}`} className="ml-auto inline-flex items-center justify-center w-7 h-7 rounded-full bg-[#25D366]/15 text-[#25D366] hover:bg-[#25D366] hover:text-white transition-colors">
    <WhatsAppIcon className="w-4 h-4" />
  </a>
);

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0A0B0E] mt-24" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-10">
      <div>
        <div className="mb-4">
          <img src="/logo-colored.png" alt="Centro Auto Pontedera" className="h-20 w-auto" />
        </div>
        <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">Noleggio, vendita auto e carrozzeria a Pontedera dal 1970. Verniciatura a forno, riparazione grandine, sinistri e auto sostitutiva.</p>
        <div className="flex flex-wrap items-center gap-3 mt-6" data-testid="footer-actions">
          <ShareButton />
          <InstallAppButton />
        </div>
        <div className="flex items-center gap-3 mt-5">
          <a href="https://facebook.com/centroautopontedera" target="_blank" rel="noopener noreferrer" aria-label="Facebook" data-testid="social-facebook" className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#E63946] flex items-center justify-center transition-colors">
            <Facebook className="w-5 h-5" />
          </a>
          <a href="https://www.instagram.com/centro_auto_pontedera" target="_blank" rel="noopener noreferrer" aria-label="Instagram" data-testid="social-instagram" className="w-10 h-10 rounded-full bg-white/5 hover:bg-[#E63946] flex items-center justify-center transition-colors">
            <Instagram className="w-5 h-5" />
          </a>
        </div>
      </div>
      <div>
        <h4 className="font-mono-tech text-xs tracking-widest uppercase text-muted-foreground mb-4">Contatti</h4>
        <ul className="space-y-3 text-sm">
          <li className="flex items-center gap-3"><Phone className="w-4 h-4 amber shrink-0" /> <a href="tel:+390587484791" className="hover:text-foreground" data-testid="phone-fisso">0587 484791</a></li>
          <li className="flex items-center gap-3"><Phone className="w-4 h-4 amber shrink-0" /> Massimo <a href="tel:+393206062816" className="hover:text-foreground">320 6062816</a> <WaBtn num="393206062816" name="Massimo" /></li>
          <li className="flex items-center gap-3"><Phone className="w-4 h-4 amber shrink-0" /> Elisa <a href="tel:+393283559800" className="hover:text-foreground">328 3559800</a> <WaBtn num="393283559800" name="Elisa" /></li>
          <li className="flex items-center gap-3"><Mail className="w-4 h-4 amber shrink-0" /> <a href="mailto:info@centroautopontedera.it" className="hover:text-foreground break-all" data-testid="email-link">info@centroautopontedera.it</a></li>
          <li className="flex items-start gap-3"><MapPin className="w-4 h-4 amber shrink-0 mt-0.5" /> <a href="https://www.google.com/maps/search/?api=1&query=Via+Don+Primo+Mazzolari+38+Pontedera+PI" target="_blank" rel="noopener noreferrer" className="hover:text-foreground" data-testid="maps-link">Via Don Primo Mazzolari 34/38, Pontedera (PI)</a></li>
        </ul>
      </div>
      <div>
        <h4 className="font-mono-tech text-xs tracking-widest uppercase text-muted-foreground mb-4">Carrozzeria</h4>
        <ul className="space-y-2 text-sm mb-8" data-testid="footer-bodyshop-links">
          <li><Link to="/carrozzeria-pontedera" className="text-muted-foreground hover:text-foreground transition-colors">Carrozzeria a Pontedera</Link></li>
          <li><Link to="/riparazione-grandine" className="text-muted-foreground hover:text-foreground transition-colors">Riparazione grandine</Link></li>
        </ul>
        <h4 className="font-mono-tech text-xs tracking-widest uppercase text-muted-foreground mb-4">Garanzie</h4>
        <ul className="space-y-3 text-sm text-muted-foreground">
          <li>Cauzione trasparente e rimborsabile</li>
          <li>Nessun costo nascosto</li>
          <li>Pagamento flessibile</li>
        </ul>
        <h4 className="font-mono-tech text-xs tracking-widest uppercase text-muted-foreground mb-4 mt-8">Noleggio auto</h4>
        <ul className="space-y-2 text-sm" data-testid="footer-seo-links">
          {LANDING_LINKS.map(([to, label]) => (
            <li key={to}><Link to={to} className="text-muted-foreground hover:text-foreground transition-colors">{label}</Link></li>
          ))}
        </ul>
      </div>
    </div>
    <div className="border-t border-white/10 py-6 text-center text-xs text-muted-foreground font-mono-tech tracking-wider">© 2026 CENTRO AUTO PONTEDERA — TUTTI I DIRITTI RISERVATI</div>
  </footer>
);
